/**
 * Old links — /admin/drop-generator[/:countryKey] and the removed
 * /admin/automations[/:countryKey] — land on the same Automation page,
 * query string kept (?container=, ?group=, ?tab=… still open the same view).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { AUTOMATION_PATH, automationCountryPath } from '@/features/drop-generator/utils/automation-paths';

export const LegacyAutomationRedirect: FC = () => {
  const { countryKey } = useParams<{ countryKey?: string }>();
  const { search } = useLocation();
  return <Navigate to={countryKey ? automationCountryPath(countryKey, search) : `${AUTOMATION_PATH}${search}`} replace />;
};
